import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'rt-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.less'],
})
export class CompanyLogoComponent {
  public readonly logoThumbUrl: InputSignal<string | undefined | null> = input();
}
